/**
 * Constants.ts
 *
 * Module to hold logging-related constants
 */
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
export class EventIds {}
EventIds.InApp = (_a = class {}, _a.UI = (_b = class {}, _b.Picker = (_c = class {}, _c.Shown = (_d = class {}, _d.VALUE = {
  name: "InApp_UI_Picker_Shown"
}, _d), _c), _b.Form = (_e = class {}, _e.Shown = (_f = class {}, _f.VALUE = {
  name: "InApp_UI_Form_Shown"
}, _f), _e.Submit = (_g = class {}, _g.VALUE = {
  name: "InApp_UI_Form_Submit"
}, _g), _e), _b), _a);
// This saves ~400 bytes (minified) vs nested classes
EventIds.SURVEY_FLOODGATE_CAMPAIGNLOAD_FAILED = {
  name: "Survey_Floodgate_CampaignLoad_Failed"
};
EventIds.SURVEY_FLOODGATE_FILEREAD_FAILED = {
  name: "Survey_Floodgate_FileRead_Failed"
};
EventIds.SURVEY_FLOODGATE_FILEWRITE_FAILED = {
  name: "Survey_Floodgate_FileWrite_Failed"
};
EventIds.SURVEY_FLOODGATE_TRIGGERMET = {
  name: "Survey_Floodgate_TriggerMet"
};
EventIds.SURVEY_FLOODGATE_USERSELECTED = {
  name: "Survey_Floodgate_UserSelected"
};
EventIds.SURVEY_UI_FORM_SHOWN = {
  name: "Survey_UI_Form_Shown"
};
EventIds.SURVEY_UI_FORM_SUBMIT = {
  name: "Survey_UI_Form_Submit"
};
EventIds.SURVEY_UI_FORM_USERCLOSED = {
  name: "Survey_UI_Form_UserClosed"
};
EventIds.SURVEY_UI_PROMPT_AUTODISMISSED = {
  name: "Survey_UI_Prompt_AutoDismissed"
};
EventIds.SURVEY_UI_PROMPT_SHOWN = {
  name: "Survey_UI_Prompt_Shown"
};
EventIds.SURVEY_UI_PROMPT_USERCLOSED = {
  name: "Survey_UI_Prompt_UserClosed"
};
EventIds.SURVEY_UI_PROMPT_CLICKED = {
  name: "Survey_UI_Prompt_Clicked"
};
EventIds.SURVEY_UI_REDIRECTIONFAILURE = {
  name: "Survey_UI_RedirectionFailure"
};
EventIds.GOVERNANCE_SERVICEFAILURE = {
  name: "Gorvenance_ServiceFailure"
};
EventIds.GOVERNANCE_SERVICERESULT = {
  name: "Gorvenance_ServiceResult"
};
EventIds.DYNAMICTRANSPORT_POST_ERROR = {
  name: "DynamicTransport_Post_Error"
};
EventIds.FEEDBACK_SURVEYSDISABLED_AADC = {
  name: "Feedback_SurveysDisabled_AADC"
};
EventIds.SURVEY_UI_DISABLED_AADC = {
  name: "Survey_UI_Prevented_AADC"
};
EventIds.Shared = (_h = class {}, _h.Upload = (_j = class {}, _j.Failed = (_k = class {}, _k.VALUE = {
  name: "Shared_Upload_Failed"
}, _k), _j.Prevented = (_l = class {}, _l.VALUE = {
  name: "Shared_Upload_Prevented_AADC"
}, _l), _j), _h.Screenshot = (_m = class {}, _m.Render = (_o = class {}, _o.Failed = (_p = class {}, _p.VALUE = {
  name: "Shared_Screenshot_Render_Failed"
}, _p), _o.Success = (_q = class {}, _q.VALUE = {
  name: "Shared_Screenshot_Render_Success"
}, _q), _o), _m.GetContent = (_r = class {}, _r.Failed = (_s = class {}, _s.DefaultImage = (_t = class {}, _t.Returned = (_u = class {}, _u.VALUE = {
  name: "Shared_Screenshot_GetContent_Failed_DefaultImage_Returned"
}, _u), _t), _s), _r), _m), _h);
EventIds.WebSurfaces = (_v = class {}, _v.Common = (_w = class {}, _w.Error = (_x = class {}, _x.VALUE = {
  name: "WebSurfaces_Common_Error"
}, _x), _w.Info = (_y = class {}, _y.VALUE = {
  name: "WebSurfaces_Common_Info"
}, _y), _w), _v.Messaging = (_z = class {}, _z.Requests = (_0 = class {}, _0.VALUE = {
  name: "WebSurfaces_Messaging_Requests"
}, _0), _z), _v);
EventIds.UserFacts = (_1 = class {}, _1.Common = (_2 = class {}, _2.Error = (_3 = class {}, _3.VALUE = {
  name: "UserFacts_Common_Error"
}, _3), _2.Info = (_4 = class {}, _4.VALUE = {
  name: "UserFacts_Common_Info"
}, _4), _2), _1.Messaging = (_5 = class {}, _5.Requests = (_6 = class {}, _6.VALUE = {
  name: "UserFacts_Messaging_Requests"
}, _6), _5), _1.AugLoop = (_7 = class {}, _7.Requests = (_8 = class {}, _8.VALUE = {
  name: "UserFacts_AugLoop_Requests"
}, _8), _7.Error = (_9 = class {}, _9.VALUE = {
  name: "UserFacts_AugLoop_Error"
}, _9), _7), _1.Provider = (_10 = class {}, _10.Info = (_11 = class {}, _11.VALUE = {
  name: "UserFacts_Provider_Summary"
}, _11), _10), _1);
EventIds.Common = (_12 = class {}, _12.Error = (_13 = class {}, _13.VALUE = {
  name: "Common_Error"
}, _13), _12.Info = (_14 = class {}, _14.VALUE = {
  name: "Common_Info"
}, _14), _12);